import { render, staticRenderFns } from "./SelectCurrencyDrawer.vue?vue&type=template&id=245878c4&"
import script from "./SelectCurrencyDrawer.vue?vue&type=script&lang=js&"
export * from "./SelectCurrencyDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports